// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"193":"4055c53d","308":"f56e560d","526":"b1ab5441","532":"b1ab5441","758":"b1ab5441"}[chunkId] + ".chunk.css";
};